export default "__VITE_ASSET__BG8i95Q___"